import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SubscriptionCategory } from '../../../../common/enums.js';
import { UserDetails } from '../../../../components/UserDetails/UserDetails.js';
import { getEmployeeSubscriptions } from '../../../../selfservice/actions/index.js';
import { useAuth } from '../../AuthProvider.js';
import { useSessionData } from '../../SessionDataProvider.js';

export const EoeOwnInfoPath = () => {
  const { authenticatedUser } = useAuth();
  const companyInfo = useSessionData().companyInfo;
  const dispatch = useDispatch();

  useEffect(() => {
    if (authenticatedUser?.businessId) {
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.SERVICE));
    }
  }, [dispatch, authenticatedUser?.businessId]);

  return <UserDetails companyInfo={companyInfo} />;
};
